<div class="z-progress-wrapper">
  <div class="z-progress-steps z-fx-col z-fx-center-center">
    @if (showTopArrow | async) {
      <span class="z-first" [style.color]="(ss.colors | async).text" (click)="gotoIndex(index$.getValue() - 1)"></span>
    }

    @for (step of steps | async; track step) {
      <figure
        [class.active]="(index$ | async) === step"
        [style.background-color]="(ss.colors | async).text"
        (click)="gotoIndex(step)"
      ></figure>
    }

    @if (showBottomArrow | async) {
      <span class="z-last" [style.color]="(ss.colors | async).text" (click)="gotoIndex(index$.getValue() + 1)"></span>
    }
  </div>
</div>
